import { ClientSegmentType } from '@/interfaces';

export const getSegmentClientColor = (label: ClientSegmentType): string => {
	const colors: Record<ClientSegmentType, string> = {
		'Closed Account Customer': '#EB35CE',
		'Flagged Customer': '#FF0043',
		'Disengaged Customer': '#FD9834',
		'In-Progress Customer': '#2084E7',
		'One-Time Customer': '#2D41F5',
		'Recently Registered Customer': '#40BB71',
		'Repeat Customer': '#8F20EF',
		'Unverified Accounts': '#4A4A4A',
		'Deleted Accounts': '#4A4A4A',
		'Deactivated Accounts': '#4A4A4A',
	};
	return colors[label];
};
